export function absoluteDifference(num1: number, num2: number): number {
    return Math.abs(num1 - num2);
}